"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleClickedValue = exports.toggleClickedKey = exports.keysToRemove = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _uiKit = require("@icis/ui-kit");
var _HomePageToggle = require("./HomePageToggle.styles");
var _schemaVersion = require("../../constants/schemaVersion");
var _l10n = require("../../l10n");
var _getShowHomepageToggle = _interopRequireDefault(require("../../utils/getShowHomepageToggle"));
var _webStorage = _interopRequireDefault(require("../../utils/webStorage"));
const toggleClickedKey = exports.toggleClickedKey = 'toggleClicked';
const toggleClickedValue = exports.toggleClickedValue = 'NewHome';
const keysToRemove = exports.keysToRemove = ['home.apollo', 'homepage-v2.apollo', "nav-en-".concat(_schemaVersion.SCHEMA_VERSION), "nav-zh-".concat(_schemaVersion.SCHEMA_VERSION), "nav-en-hp2-".concat(_schemaVersion.SCHEMA_VERSION), "nav-zh-hp2-".concat(_schemaVersion.SCHEMA_VERSION)];
const HomePageToggle = _ref => {
  let {
    appConfig,
    mutateHomepageToggle,
    data,
    id,
    locale
  } = _ref;
  const {
    hp2Migrate = false
  } = data.preferences || {};
  const showHomepageToggle = (0, _getShowHomepageToggle.default)(data);
  const translate = (0, _l10n.getMessages)(locale);
  if (!showHomepageToggle) {
    return null;
  }
  const onHomepageToggle = async () => {
    const navigateTo = hp2Migrate ? appConfig.urls.homepageV1Url : appConfig.urls.homepageV2Url;
    await mutateHomepageToggle({
      variables: {
        hp2Migrate: !hp2Migrate
      }
    });
    const webStorage = (0, _webStorage.default)();
    keysToRemove.forEach(key => webStorage.remove(key));
    webStorage.set('homeUrl', hp2Migrate ? '/' : '/home');
    webStorage.set(toggleClickedKey, toggleClickedValue);
    setTimeout(() => window.location.assign(navigateTo), 500);
  };
  return /*#__PURE__*/_react.default.createElement(_HomePageToggle.HomePageToggleContainer, {
    "data-testid": id,
    "data-walkmeid": "shared-header-toggle-".concat(hp2Migrate ? 'on' : 'off')
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Toggle, {
    leftLabel: true,
    testId: "new-homepage-toggle-checkbox",
    value: hp2Migrate,
    onChange: onHomepageToggle,
    label: translate('HeaderMenus.Main.NewHome')
  }));
};
var _default = exports.default = HomePageToggle;